<div class="icon-grid">
  @if (isTeacherOrEducatorStaffMember) {
    <div class="tile" matTooltip="Présences par classe">
      <a routerLink="admin/students/justificationsByClass" data-cy="go-to-justifications-by-class-page">
        <mat-icon inline>how_to_reg</mat-icon>
      </a>
    </div>
  }
</div>
